<div class="mt-8">

    <div class="w-full flex justify-between mb-4">
        <app-btn-back routeTo=".." icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="text-center flex justify-between items-center">
        <h6 class="text-primary-500 text-lg font-bold uppercase">
            Edit Child Profile
        </h6>
    </div>

    <div class="w-full">

        <div class="grid place-items-center w-full p-4">
            <input hidden type="file" #profileImage (change)="uploadFile($event)">
            @if (student?.photoURL) {
            <div class="relative rounded-full h-48 w-48">
                <img [src]="student?.photoURL"
                    class="min-h-48 max-h-48 max-w-48 min-w-48 px-auto bg-white rounded-full self-center object-cover shadow-lg border-none" />
                <button (click)="profileImage.click()"
                    class="absolute h-12 w-12 bottom-2 right-3 bg-white text-primary-500 hover:text-white hover:bg-primary-500 text-sm uppercase font-bold px-4 py-2 rounded-full outline-none focus:outline-none shadow ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-edit leading-relaxed"></i>
                </button>
                <button (click)="deleteProfileImage()"
                    class="absolute h-12 w-12 bottom-14 -right-4 bg-white text-red-500 hover:bg-red-500 hover:text-white text-sm uppercase font-bold px-4 py-2 rounded-full outline-none focus:outline-none shadow ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-trash-can leading-relaxed"></i>
                </button>
                @if (progress != null) {
                <p class="absolute bg-primary-500 text-white top-1/2 left-2 z-10 px-2">
                    {{progress}}</p>
                }
            </div>
            } @else {
            <div
                class="relative bg-primary-100 h-48 w-48 object-cover uppercase text-primary-500 text-2xl flex justify-center items-center text-center rounded-full shadow-lg">
                <p class="z-10 px-2">{{progress
                    ?? (student?.name! | initials)}}</p>

                <button type="button" (click)="profileImage.click()"
                    class="absolute h-12 w-12 bottom-3 right-3 bg-white text-primary-500 hover:bg-primary-500 hover:text-white text-sm uppercase font-bold px-4 py-2 rounded-full outline-none focus:outline-none shadow ease-linear transition-all duration-150"><i
                        class="fa fa-edit leading-relaxed"></i>
                </button>
            </div>
            }
        </div>

        <form [formGroup]="pageForm" (submit)="update()">

            <div class="flex flex-wrap w-full relative">

                <div class="w-full mb-6">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Student Name
                    </label>
                    <input type="text" name="name" formControlName="name" placeholder="Student Name"
                        class="border-0 px-3 py-3 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                </div>

                <div class="flex flex-row gap-4 w-full mb-6">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Date of Birth
                        </label>
                        <input type="date" name="dob" formControlName="dob" placeholder="dd/mm/yyyy"
                            class="border-0 px-3 py-3 placeholder:text-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            min="1900-01-01" [max]="today">
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Gender
                        </label>
                        <app-gender name="gender" formControlName="gender"></app-gender>
                    </div>
                </div>

                <div class="w-full mb-6">
                    <app-checkbox formControlName="showDob" label="Show Date of Birth to Group Members"></app-checkbox>
                </div>

                <div class="w-full">
                    <app-btn-submit [isDisabled]="pageForm.invalid || working" [isLoading]="working" [actionText]="'Update'"
                        [icon]="'fa fa-save'"></app-btn-submit>
                </div>
            </div>
        </form>
    </div>
</div>